import { Dispatch } from 'redux';

import * as Actions from '../actions/skillMap';
import AbstractScenario from './AbstractScenario';

const keySkillMapData = 'per_skill_SkillMapDataModel';
const keySkillMapDataRoot = 'per_skill_SkillMapDataRootModel';
const keyCellDetail = 'per_skill_SkillMapDetailDataModel';
const keyHistoryInfo = 'per_skill_SkillMapHistoryDataModel';
const keyTargetInfo = 'per_skill_SkillMapUpdateTargetInfoModel';
const keyResetTargetInfo = 'per_skill_SkillMapResetTargetInfoModel';

export default class SkillMapScenarioFactory {
	/**
	 * スキルマップデータを取得する。
	 * １．分野データ
	 * ２．レベルデータ
	 * ３．マスタデータ
	 * ４．最終更新情報データ
	 * @param dispatch dispatch
	 * @param token token
	 */
	public static getSkillMapData(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process(jouken: any) {
				return this.read(keySkillMapData, {
					...jouken,
					accessType: 10,
				}).then(data => {
					this.dispatch(
						Actions.setSkillMapData({
							applyFlg: data.applyFlg,
							divisionData: data.divisionData,
							levelData: data.levelData,
							masterData: data.masterData,
							rootDivision: data.rootDivisions,
							updateInfo: data.updateInfo,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * スキルマップデータを取得する。
	 * １．分野データ
	 * ２．レベルデータ
	 * @param dispatch dispatch
	 * @param token token
	 */
	public static getSkillMapDataByRootId(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process(jouken: any) {
				return this.read(keySkillMapDataRoot, {
					accessType: 10,
					cmId: jouken.cmId,
					rootId: jouken.rootId,
					userId: jouken.userId,
				}).then(data => {
					this.dispatch(
						Actions.setSkillMapData({
							applyFlg: data.applyFlg,
							divisionData: data.divisionData,
							levelData: data.levelData,
							masterData: {
								division1Color: '',
								division2Color: '',
								division3Color: '',
								goalCompleteColor: '',
								longGoalColor: '',
								shortGoalColor: '',
							},
							rootDivision: [],
							updateInfo: {
								skillMapName: '',
								updateTime: '',
								updator: '',
							},
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * セル詳細データを取得する。
	 * @param dispatch dispatch
	 * @param token token
	 */
	public static getCellDetail(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.IFetchJoken
		> {
			protected process(joken: Actions.IFetchJoken) {
				return this.read(keyCellDetail, {
					accessType: 10,
					cmId: joken.cmId,
					cmcId: joken.cmcId,
					userId: joken.userId,
				}).then(data => {
					if (data.length > 0) {
						this.dispatch(Actions.setDetailData([...data]));
					} else {
						this.dispatch(Actions.setDetailData([]));
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 更新履歴データを取得する。
	 * @param dispatch dispatch
	 * @param token token
	 */
	public static getHistory(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.IFetchHistoryJoken
		> {
			protected process(joken: Actions.IFetchHistoryJoken) {
				return this.read(keyHistoryInfo, {
					accessType: 10,
					cmId: joken.cmId,
					userId: joken.userId,
				}).then(data => {
					if (data.length > 0) {
						this.dispatch(Actions.setHistoryData([...data]));
					} else {
						this.dispatch(Actions.setHistoryData([]));
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * セルの目標とコメントを更新する。
	 * @param dispatch dispatch
	 * @param token token
	 */
	public static setTargetInfo(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.ITargetSetParam
		> {
			protected process(joken: Actions.ITargetSetParam) {
				return this.update(keyTargetInfo, {
					accessType: 10,
					adminView: joken.adminView,
					cmId: joken.cmId,
					cmcId: joken.cmcId,
					comment: joken.comment,
					target: joken.target === -1 ? 0 : joken.target,
					userId: joken.userId,
				}).then(data => {
					this.dispatch(Actions.setLastUpdateData(data));
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 目標設定解除
	 * @param dispatch dispatch
	 * @param token token
	 */
	public static resetTargetInfo(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.ITargetSetParam
		> {
			protected process(joken: Actions.ITargetSetParam) {
				return this.update(keyResetTargetInfo, {
					accessType: 10,
					adminView: joken.adminView,
					cmId: joken.cmId,
					cmcId: joken.cmcId,
					comment: joken.comment,
					target: joken.target,
					userId: joken.userId,
				}).then(data => {
					this.dispatch(Actions.setLastUpdateData(data));
				});
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/SkillMapScenarioFactory.ts